import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DropDownMenuComboLink from "@mnjsplatform/components/lib/common/DropdownMenu/DropDownMenuComboLink";
import i18next from "i18next";

class TransportReqCardShowModeMenu extends Component {
  render() {
    let showModeText = this.props.currentShowMode === 0 ? i18next.t("ViewMode_Short") : this.props.currentShowMode === 1 ? i18next.t("ViewMode_Optimal") : i18next.t("ViewMode_Full");
    const menuProvider = new CardShowModeMenuProvider(this.props.currentShowMode);
    let self = this;

    return (
      <React.Fragment>
        <div className="field-title fs16" style={{display: "flex", alignItems: "center", marginLeft: "15px", marginRight: "10px"}}>
          <span style={{display: "flex"}}>{i18next.t("ViewMode")}: {showModeText}</span>
        </div>
        <div>
          <DropDownMenuComboLink menuAdapter={menuProvider}
                                 onSelected={(menuItem) => { self.props.onModeSelect(menuItem.MenuItemId);}}
                                 alignRight
          />
        </div>
      </React.Fragment>
    );
  }
}

class CardShowModeMenuProvider {

  constructor(currentShowMode) {

    this.items = [];

    this.items[0] = {
      MenuItemId: 0,
      MenuText: i18next.t("ViewMode_Short"),
      IsActive: currentShowMode === 0
    };

    this.items[1] = {
      MenuItemId: 1,
      MenuText: i18next.t("ViewMode_Optimal"),
      IsActive: currentShowMode === 1
    };

    this.items[2] = {
      MenuItemId: 2,
      MenuText: i18next.t("ViewMode_Full"),
      IsActive: currentShowMode === 2
    };
  }

  getMenuItems() {
    return this.items;
  }

  getVisibleItemsCount() {
    return 1;
  }

  getDropDownText() {
    /*const i = this.items.find(i => i.MenuItemId === this.currentShowMode);

    if (i) {
      return i.MenuText + "";
    }*/

    return "";
  }
}

TransportReqCardShowModeMenu.propTypes = {
  currentShowMode: PropTypes.number,
  onModeSelect: PropTypes.func.isRequired
};

TransportReqCardShowModeMenu.defaultProps = {
};

function mapStateToProps(state, ownProps) {
  return {};
}

export default connect(mapStateToProps)(TransportReqCardShowModeMenu);